import { createContext, useContext } from "react"

/**
 * True inside the driver workspace — the split layout with the Slick AI column
 * and the widget panel. Message rows and day markers render differently there,
 * and they have no other way to tell: a driver room looks the same to them in
 * both layouts.
 *
 * Deliberately not a feature-flag read. The flag decides which layout mounts;
 * everything below the layout just asks which layout it is in.
 */
const DriverWorkspaceContext = createContext(false)

export const DriverWorkspaceProvider = DriverWorkspaceContext.Provider

export const useIsDriverWorkspace = (): boolean =>
  useContext(DriverWorkspaceContext)
